import { IconCheck } from 'featherico';
import Button from '../../components/Button';
import { DeprecatedButtonContainer } from '../../components/ButtonContainer';
import UiPopover from '../../components/UiPopover';
import styles from './style.m.less';

interface Props {
    onDismiss: () => void;
}

export function WritingAssistantSparkContent({ onDismiss }: Props): JSX.Element {
    return (
        <UiPopover direction="left">
            <div className={styles.sparkContent}>
                <div>
                    <h3 className={styles.sparkTitle}>AI Writing Assistant</h3>
                </div>
                <div>
                    Take your feedback to the next level. Simply write your thoughts and use the Writing Assistant to
                    get AI-powered suggestions.
                </div>
                <DeprecatedButtonContainer>
                    <Button kind="PRIMARY" isSmall={true} onClick={onDismiss} autoFocus className={styles.sparkButton}>
                        <span>
                            Got it <IconCheck />
                        </span>
                    </Button>
                </DeprecatedButtonContainer>
            </div>
        </UiPopover>
    );
}
